var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMushrooms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1C8079;}\n\t.st1{fill:#F1F1F1;}\n\t.st2{fill:#CDCBCC;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M108.25,126.19c-0.24,1.05-0.3,2.07-0.33,3.12c-0.06,1.05-0.09,2.04-0.36,2.91c-0.57,1.89-2.37,3.54-4.8,4.35 c-2.34,0.81-5.01,0.84-7.56,0.9c-1.62,0-3.48,0.03-4.83-0.72c-1.44-0.78-2.4-2.46-3.18-3.96c-1.62-3.09-3.39-7.14-2.88-11.16 c0.3-2.31,1.35-4.5,2.43-6.78c0.54-1.11,1.08-2.25,1.53-3.42c0.09-0.21,0.15-0.39,0.24-0.6c2.49,0.45,9.81,1.68,13.38,0.75 c-0.66,3.09-0.6,6.36,0.12,9.57C102.58,123.61,104.65,125.32,108.25,126.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M106.9,101.83c-1.26,1.32-2.34,2.82-3.18,4.47c-0.87,1.68,3.69,11.83,3.33,13.66 c-3.57,0.93-16.05-8.68-18.54-9.13c1.05-2.88,1.63-5.12,1.69-8.18c3,0.09,6.05-0.73,9.11-0.73 C101.86,101.92,104.44,101.89,106.9,101.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M125.75,79.42c-3.11-6.69-9.08-11.89-16-13.91c-5-1.49-10.43-1.39-15.67-1.26c-4.34,0.07-8.84,0.17-12.75,1.89 c-2.81,1.19-5.2,3.21-6.99,4.84c-4.14,3.78-6.99,7.45-8.71,11.26c-2.05,4.5-2.42,9.37-1.06,13.35c0.63,1.82,3.17,4.28,4.33,5.14 c0.54-2.17-0.32-1.54,2.63-4.98c0.46-0.56,1.78-1.84,2.45-1.54c0.66,0.3-0.17,1.72-0.27,2.45c-0.53,4.11-0.02,0.93-0.18,5.07 l2.44,0.29h0.36c3.34,0.1,7.12,0.23,11.06,0.36h0.03c0.13-0.03,0.27-0.07,0.4-0.07c0.2,0,0.4,0,0.56,0.1 c7.85,0.17,16.36,0.23,24.01-0.17c1.52-0.96,3.15-1.69,4.84-2.19c2.88-0.83,6.16-1.03,9.74-0.56 C129.06,92.83,128.63,85.61,125.75,79.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.12,139.9c-0.09,0.15-0.3,0.39-1.02,0.69c-2.67,1.11-5.97,1.17-10.08,0.21c-1.02-0.24-2.01-0.54-2.55-1.14 c-0.54-0.6-0.72-1.68-0.48-2.88c0.15-0.81,0.48-1.62,0.78-2.49c0.21-0.48,0.39-0.96,0.54-1.47c0.18-0.57,0.36-1.14,0.48-1.71 l10.59,0.48c0.15,0.48,0.33,0.99,0.51,1.47c0.18,0.45,0.33,0.9,0.48,1.35c0.48,1.53,0.75,3.09,0.81,4.68 C130.18,139.27,130.21,139.69,130.12,139.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M128.38,131.59l-10.59-0.48c0.3-1.38,0.45-2.79,0.42-4.23c3.03-0.03,6.24-0.15,9.81-0.36 c-0.3,1.11-0.3,2.37,0,3.75C128.11,130.72,128.23,131.17,128.38,131.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M144,104.32c-4.18-5.02-10.58-7.28-15.22-8.36c-0.58-0.11-1.15-0.23-1.69-0.34c-0.27,0.08-0.58,0.04-0.84-0.08 c-0.04-0.04-0.12-0.04-0.15-0.08c-1.65-0.27-3.22-0.38-4.68-0.38c-2.18,0-4.18,0.27-6.06,0.8c-1.49,0.42-2.91,1.03-4.25,1.88 c-0.31,0.38-0.73,0.65-1.23,0.73h-0.04c-2.8,1.95-5.21,4.68-6.82,7.78c-2.45,4.79-3.14,10.77-1.88,16.33 c0.65,2.72,5.25,4.29,12.69,4.37c6.78,0.08,14.34-0.23,23.73-0.88c3.22-0.23,6.82-0.65,8.78-2.84c0.96-1.07,1.57-2.72,1.8-4.83 C148.76,113.45,147.18,108.16,144,104.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M68.52,100.47c0,0,1.66,1.83,21.21,1.93s-2.76-17.06-2.76-17.06l-15.12,2.74L68.52,100.47z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMushrooms);
export default __webpack_public_path__ + "static/media/Mushrooms.2f27becbb69a11849ad96c40f16c7dec.svg";
export { ForwardRef as ReactComponent };